const logLevels = {
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
  };
  
  const log = (level, message, ...optionalParams) => {
    if (process.env.NODE_ENV !== 'production') {
      switch (level) {
        case logLevels.INFO:
          console.info(message, ...optionalParams);
          break;
        case logLevels.WARN:
          console.warn(message, ...optionalParams);
          break;
        case logLevels.ERROR:
          console.error(message, ...optionalParams);
          break;
        default:
          console.log(message, ...optionalParams);
      }
    }
  };
  
  export const logger = {
    info: (message, ...optionalParams) => log(logLevels.INFO, message, ...optionalParams),
    warn: (message, ...optionalParams) => log(logLevels.WARN, message, ...optionalParams),
    error: (message, ...optionalParams) => log(logLevels.ERROR, message, ...optionalParams),
  };